// Leave (models.TimeOff) as the screens show it: its types and states, and
// their colours. Shared by Ingeniería > Ausencias and Personas.
import { currentLocale } from '../i18n'

export const TIPOS = ['PTO', 'medical', 'work_trip', 'admin', 'permiso']
// What someone asks for in Personas (backend ausencias.PEDIBLES): licences and
// permissions are seen with HR, in Buk, and come from there.
export const PEDIBLES = ['PTO', 'admin', 'work_trip']

export const TIPO_COLORES = {
  PTO: 'bg-emerald-100 text-emerald-700',
  medical: 'bg-red-100 text-red-700',
  work_trip: 'bg-blue-100 text-blue-700',
  admin: 'bg-amber-100 text-amber-700',
  permiso: 'bg-violet-100 text-violet-700',
}

// The calendar's cell colour per type (Personas > Calendario).
export const TIPO_CELDA = {
  PTO: '#6ee7b7', admin: '#fcd34d', medical: '#fca5a5', permiso: '#c4b5fd', work_trip: '#93c5fd',
}

// backend ausencias.ESTADOS
export const ESTADOS = ['pendiente', 'aprobada', 'rechazada', 'cancelada']

export const ESTADO_COLORES = {
  pendiente: 'bg-amber-50 text-amber-700 ring-1 ring-amber-200',
  aprobada: 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200',
  rechazada: 'bg-red-50 text-red-700 ring-1 ring-red-200',
  cancelada: 'bg-gray-100 text-gray-500 ring-1 ring-gray-200',
}

// "3 oct – 10 oct 2026", or one date when it is a single day.
export function rangoFechas(desde, hasta) {
  const fmt = (d, conAnio) => new Date(d + 'T00:00:00').toLocaleDateString(currentLocale(), {
    day: 'numeric', month: 'short', ...(conAnio ? { year: 'numeric' } : {}),
  })
  if (desde === hasta) return fmt(desde, true)
  const mismoAnio = desde.slice(0, 4) === hasta.slice(0, 4)
  return `${fmt(desde, !mismoAnio)} – ${fmt(hasta, true)}`
}

// Calendar days from one ISO date to another, both included.
export function diasCorridos(desde, hasta) {
  const ms = new Date(hasta + 'T00:00:00') - new Date(desde + 'T00:00:00')
  return Math.round(ms / 86400000) + 1
}
